$( document ).ready(function() {
    $(document).trigger('lastDocumentReady');
});
$(document).on("lastDocumentReady", function () {
    var confirm_nav_ignore = [];

    function confirm_nav() {

        function save_form_state($form) {
            var old_state = $form.serialize();
            $form.data('old_state', old_state);
        }

        // On load, save form current state
        $('.confirm-leaving-form').each(function() {
            save_form_state($(this));
        });


        // strip fields that we should ignore
        function strip(form_data) {
            for (var i=0; i<confirm_nav_ignore.length; i++) {
                var field = confirm_nav_ignore[i];
                form_data = form_data.replace(new RegExp("\\b"+field+"=[^&]*"), '');
            }
            return form_data;
        }

        // Before unload, confirm navigation if any field has been edited
        $(window).on('beforeunload', function(e) {
            var rv;
            $('.confirm-leaving-form').each(function() {
                var $form = $(this);
                var old_state = strip($form.data('old_state'));
                var new_state = strip($form.serialize());
                if (new_state != old_state) {
                    rv = '';
                }
            });
            return rv;
        });

        $(".confirm-leaving-form").on("submit", function(e) {
            // e.preventDefault();
            save_form_state($(this));
            $(window).off("beforeunload");
            return true;
        });
    }

    confirm_nav();


});


// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/confirm-leqaving-form.js